export default "__VITE_ASSET__Dw0Y1cmW__"